import { resolveHTTP } from '@/services/api'

const Api = resolveHTTP('/activations')

Api.force = (user, options) => {
  return Api.resource.post(`/force/${user.email}`, Api.parseOptions(options))
}

Api.resend = (user, options) => {
  return Api.resource.post(`/resend/${user.email}`, Api.parseOptions(options))
}

export default Api



// WEBPACK FOOTER //
// ./src/services/api/sys-activations.js